<template>
  <div class="search-languages">
    <div class="search-languages__title">
      <af-h3>Välj språk</af-h3>
    </div>
    <div class="search-languages__search">
      <div class="search-languages__search-result">
        <search-language
          v-for="item in defaultLanguages"
          :key="item.path"
          :name="item.name"
          :path="item.path">
          {{ item.name }}
        </search-language>
      </div>
      <div class="search-languages__search-wrapper">
        <search-local-search
          :list="languages"
          placeholder="Andra språk"
          queryType="languages">
        </search-local-search>
      </div>
    </div>

    <search-clear queryType="languages"></search-clear>
  </div>
</template>

<script>
import AfH3 from '@/components/AfH3'
import gql from 'graphql-tag'
import SearchLanguage from './SearchLanguage'
import Icon from '@/components/Icon'
import SearchClear from './SearchClear'
import SearchLocalSearch from './SearchLocalSearch'

export default {
  name: 'SearchLanguages',
  components: {
    AfH3,
    Icon,
    SearchClear,
    SearchLanguage,
    SearchLocalSearch
  },

  data() {
    return {
      defaultLanguages: [],
      languages: []
    }
  },

  apollo: {
    languagesData: {
      query: gql`
        query getLanguages($language: LanguageCode) {
          languageSkills(language: $language) {
            name
            path
          }
        }
      `,
      variables() {
        return {
          language: 'sv'
        }
      },
      update({ languageSkills }) {
        const defaultLanguageNames = [
          'Svenska',
          'Persiska (Farsi)',
          'Engelska',
          'Tigrinja/Tigrinska',
          'Arabiska',
          'Somaliska'
        ]

        this.languages = languageSkills
        this.defaultLanguages = languageSkills.filter(({ name }) =>
          defaultLanguageNames.includes(name)
        )
      }
    }
  }
}
</script>

<style lang="postcss" scoped>
@import '../../variables/custom-media.css';

.search-languages {
  background-color: var(--color-white);
  padding: var(--spacing) var(--spacing-medium);
}

.search-languages__title {
  display: none;

  font-size: 20px;
  font-weight: 600;
  margin-bottom: var(--spacing);

  @media (--bp-larger-than-tablet) {
    display: block;
  }
}

.search-languages__search {
  @media (--bp-desktop) {
    background-color: var(--color-porcelain);
    display: grid;
    grid-column-gap: var(--spacing);
    grid-row-gap: var(--spacing-half);
    grid-template-columns: 2fr 1fr;
    padding: var(--spacing-medium) var(--spacing-third);
  }

  @media (--ie11) {
    display: block;
  }

  @media (--ie11) and (--bp-desktop) {
    display: -ms-grid;
    -ms-grid-columns: 2fr 1fr;
    -ms-grid-rows: 1fr;
  }
}

.search-languages__search-result {
  margin-bottom: var(--spacing-third);

  @media (--bp-desktop) {
    display: grid;
    grid-column-gap: var(--spacing);
    grid-row-gap: var(--spacing-half);
    grid-template-columns: repeat(2, 1fr);
    margin-bottom: 0;
  }

  @media (--ie11) {
    display: block;
  }

  @media (--ie11) and (--bp-desktop) {
    display: -ms-grid;
    -ms-grid-columns: (1fr)[2];
    -ms-grid-rows: (1fr)[3];
    -ms-grid-column: 1;
    -ms-grid-row: 1;
  }
}

.search-languages__search-wrapper {
  position: relative;

  @media (--ie11) and (--bp-desktop) {
    margin-left: 30px;
    -ms-grid-column: 2;
    -ms-grid-row: 1;
  }
}

.search-languages__search-icon {
  position: absolute;
  top: 10px;
  left: 15px;
  font-size: 20px;
  color: var(--color-rolling-stone);
}

.search-languages__search-input {
  background: var(--color-white);
  border: 1px solid var(--color-iron);
  border-radius: 4px;
  box-sizing: border-box;
  color: #000;
  font-size: 16px;
  padding: var(--spacing-third) var(--spacing-medium) var(--spacing-third) 40px;
  width: 100%;

  @media (--bp-desktop) {
    margin-top: var(--spacing-half);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Search/SearchLanguages.vue